/**
 * 製品の名前。
 *
 * ## なぜ1か所に置くのか
 *
 * **PREIKA はシリーズの名前で、勤怠はその1つ。**給与など別の製品が
 * 続くので、画面のあちこちに「PREIKA 勤怠」と直に書くと、次の製品を
 * 出すときに同じ探し直しをやることになる。2026-08-27 に 193 か所を
 * 数えた。同じことを2回はやらない。
 *
 * ## 運営とは分ける
 *
 * <b>「PREIKA運営窓口」を「PREIKA 勤怠運営窓口」にはしない。</b>
 * 運営はシリーズを運営していて、勤怠はその1つ。給与を売り始めたときに
 * 窓口が製品ごとに分かれるわけではない。ここを混ぜると、次の製品で
 * また全部書き換えることになる。
 *
 *   製品そのもの（利用者が使っているもの） … PRODUCT_NAME
 *   シリーズ・運営（PREIKA運営、PREIKAサポート） … BRAND のまま
 *   技術的な名前（preika-* のCSS、PREIKA_AUTH_* の環境変数、
 *   ルート名、ダウンロードのファイル名） … 変えない
 */

/** シリーズの名前。**運営や、製品をまたぐ話はこちら。** */
export const BRAND = 'PREIKA'

/** この製品が扱う領域。次の製品ではここだけ変わる。 */
export const PRODUCT_AREA = '勤怠'

/**
 * 利用者に見せる製品の名前。
 *
 * <b>売るときの正式な表記。</b>間に半角空きを1つ入れる。
 */
export const PRODUCT_NAME = BRAND + ' ' + PRODUCT_AREA

/**
 * CSS からも製品の名前を読めるようにする。
 *
 * ## なぜ要るのか
 *
 * 画面の銘のいくつかは、CSS の `content:` で描かれている（ダッシュボードの
 * ヒーローと、業務画面のカード見出しの上に出る小さい字）。**CSS は JS の
 * 定数を読めない**ので、2026-08-27 の改名でそこだけ「PREIKA」のまま
 * 取り残された。検査も .vue と .js しか見ていなかったので気づけなかった。
 *
 * 見出しの上の飾りは何十画面のカードに掛かっていて、1つずつ markup へ
 * 移すのは現実的でない。**変数を1つ配って、CSS はそれを読む。**
 *
 * ## 出せなかったときは、何も出さない
 *
 * 予備の値を CSS 側に持たせると、そこがまた直書きになる。呼び忘れれば
 * 銘は空になるが、**古い名前が出るより空のほうが良い。**空はすぐ気づく。
 */
export function publishProductNameToCss (root) {
  const target = root || (typeof document === 'undefined' ? null
    : document.documentElement)
  if (!target || !target.style) { return false }
  /* content: が読める形にするため、引用符ごと入れる。 */
  target.style.setProperty('--preika-product-name', "'" + PRODUCT_NAME + "'")
  return true
}
